module.exports = __webpack_public_path__ + "img/Tablet - 73.c2d45706.png";